import { tw } from '@twind/core';
import { DidomiButton, DidomiHintbox, DidomiModal, DidomiModalActions, DidomiModalContent, DidomiModalHeader } from '@didomi/ui-atoms-react';
import type { OAuthContext } from '../types';

export type ErrorViewProps = {
  ctx: OAuthContext;
  /** When omitted, the modal is treated as open (OAuth callback and other always-visible uses). */
  isOpen?: boolean;
  /** When set, Close invokes this instead of `window.close()` (e.g. dismiss an in-flow error). */
  onClose?: () => void;
};

/** OAuth / connection error surfaced in a Didomi modal (overlay + hint details). */
export function ErrorView({ ctx, isOpen = true, onClose }: ErrorViewProps) {
  const errorTitle = ctx.error?.trim() || 'Unknown error';
  const errorDescription = ctx.error_description?.trim();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      window.close();
    }
  };

  return (
    <DidomiModal isOpen={isOpen} closable={false} returnFocusAfterClose={false}>
      <DidomiModalHeader illustrationName="warning-modal" modalTitle="Connection error" modalDescription="We couldn't complete the connection." />
      <DidomiModalContent className={tw('w-full')}>
        <DidomiHintbox titleText={errorTitle} className={tw('text-left')}>
          {errorDescription ? <p className={tw('m-0 text-sm leading-[1.45]')}>{errorDescription}</p> : null}
        </DidomiHintbox>
      </DidomiModalContent>
      <DidomiModalActions>
        <DidomiButton variant="secondary" onClick={handleClose}>
          Close
        </DidomiButton>
      </DidomiModalActions>
    </DidomiModal>
  );
}
